<template>
  <v-container fluid full-height grid-list-md>
    <v-form ref="form" v-model="valid" lazy-validation @submit.prevent="onSave">
      <v-layout row wrap>
        <v-flex xs6>
          <div class="text-xs-left">
            <v-breadcrumbs :items="breadcrumbs" divider=">">
              <template slot="item" slot-scope="props">
                <router-link
                  :to="'/' + props.item.to"
                  :disabled="props.item.disabled"
                  v-bind:class="{
                    'v-breadcrumbs__item v-breadcrumbs__item--disabled':
                      props.item.disabled,
                  }"
                  >{{ props.item.text }}</router-link
                >
              </template>
            </v-breadcrumbs>
          </div>
        </v-flex>
        <v-flex xs6>
          <div class="text-xs-right">
            <v-btn outline color="primary" @click="goBack">
              Go Back
              <v-icon right>arrow_back</v-icon>
            </v-btn>
          </div>
        </v-flex>
        <v-flex xs12>
          <v-card>
            <v-layout row wrap class="pa-3">
              <v-flex sm12 v-if="responseError">
                <span class="red--text">{{ responseError }}</span>
              </v-flex>
              <v-flex sm6>
                <v-autocomplete
                  v-model="chartOfAccount.accountheadId"
                  :items="accountHeadList"
                  color="blue-grey lighten-2"
                  label="...Select Account Head..."
                  item-text="accountName"
                  menu-props="auto"
                  item-value="id"
                  @change="changePrefix"
                  :rules="rules.accountHeadRules"
                ></v-autocomplete>
              </v-flex>
              <v-flex sm6>
                <v-text-field
                  name="code"
                  label="Account Code"
                  v-model="chartOfAccount.code"
                  type="number"
                  :prefix="prefixNo + '-'"
                  :rules="rules.accountCodeRules"
                ></v-text-field>
              </v-flex>
              <v-flex sm6>
                <v-select
                  :items="natureList"
                  label="Nature"
                  v-model="chartOfAccount.nature"
                  item-text="label"
                  item-value="value"
                  :rules="rules.coanatureRules"
                ></v-select>
              </v-flex>
              <v-flex sm6>
                <v-text-field
                  name="accName"
                  label="Account Name"
                  v-model="chartOfAccount.accName"
                  type="text"
                  :rules="rules.nameRules"
                ></v-text-field>
              </v-flex>
              <v-flex sm6>
                <v-autocomplete
                  v-model="chartOfAccount.accountTypeName"
                  :items="accountTypeList"
                  color="blue-grey lighten-2"
                  label="...Select Account Type..."
                  item-text="accTypeName"
                  menu-props="auto"
                  item-value="accTypeName"
                  :rules="rules.coatypeRules"
                ></v-autocomplete>
              </v-flex>
              <v-flex sm6> </v-flex>
              <v-flex sm2>
                <v-switch
                  :label="`Carry On`"
                  :value="carryOn"
                  v-model="carryOn"
                ></v-switch>
              </v-flex>

              <v-flex sm2 v-if="user.role.roleName == 'ADMIN'">
                <v-switch
                  :label="`Override`"
                  :value="isOverride"
                  v-model="isOverride"
                ></v-switch>
              </v-flex>
              <v-flex sm10 v-else></v-flex>

              <v-flex sm8 v-if="user.role.roleName == 'ADMIN' || user.role.roleName == 'DEPARTMENT_HEAD'">
                <v-switch
                  :label="`Is MF Account`"
                  :value="isMFAccount"
                  v-model="isMFAccount"
                ></v-switch>
              </v-flex>

              <v-flex sm2 v-if="user.role.roleName == 'ADMIN'">
                <v-switch
                  :label="`Previous Trial`"
                  :value="previousTrial"
                  v-model="previousTrial"
                ></v-switch>
              </v-flex>
              <v-flex sm2 v-else></v-flex>

              <v-flex sm2 v-if="user.role.roleName == 'ADMIN'">
                <v-switch
                  :label="`Hide Trial`"
                  :value="hideTrial"
                  v-model="hideTrial"
                ></v-switch>
              </v-flex>
              <v-flex sm2 v-else></v-flex>
              <v-flex sm8 v-if="user.role.roleName == 'ADMIN'">
                <v-switch
                  :label="`Cash`"
                  :value="isCash"
                  v-model="isCash"
                ></v-switch>
              </v-flex>
              <v-flex sm8 v-else></v-flex>

              <!--<v-flex sm12>
                <v-switch
                  :label="`Status is ${statusFlag?'Active': 'Inactive'}`"
                  :value="statusFlag"
                  v-model="statusFlag"
                ></v-switch>
              </v-flex>-->

              <v-flex>
                <v-layout row wrap>
                  <v-flex sm6>
                    <v-btn color="success" @click="showChartOfAccounts()">
                      Add Sub Account
                      <v-icon right>add</v-icon>
                    </v-btn>
                  </v-flex>
                </v-layout>
                <v-layout
                  row
                  wrap
                  class="light--text"
                  v-if="chartOfAccount.subAccountList.length > 0"
                >
                  <v-flex xs3>Sub Account Code</v-flex>
                  <v-flex xs3>Sub Account Name</v-flex>
                  <v-flex xs2>Action</v-flex>
                </v-layout>
                <v-layout
                  row
                  wrap
                  v-for="(subAccount, index) in chartOfAccount.subAccountList"
                  :key="index"
                >
                  <v-flex xs3>
                    <v-text-field
                      placeholder="Enter Sub Account code"
                      v-model="subAccount.code"
                      :prefix="subAccount.id ? '' : prefixNo + '-'"
                      :readonly="subAccount.id ? true : false"
                      :rules="
                        !subAccount.id
                          ? rules.accountCodeRules
                          : rules.codeRules
                      "
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs3>
                    <v-text-field
                      v-model="subAccount.accName"
                      placeholder="Enter Sub Account Name"
                      :readonly="subAccount.id ? true : false"
                      :rules="rules.nameRules"
                    ></v-text-field>
                  </v-flex>

                  <v-flex xs2>
                    <v-btn icon @click="removeSubAccount(index, subAccount.id)">
                      <v-icon>cancel</v-icon>
                    </v-btn>
                  </v-flex>
                </v-layout>
              </v-flex>

              <v-flex sm12>
                <div class="text-xs-center">
                  <v-btn color="error" @click="clear">
                    Reset
                    <v-icon right>clear</v-icon>
                  </v-btn>
                  <v-btn
                    color="primary"
                    :loading="saveLoading"
                    :disabled="!valid"
                    type="submit"
                  >
                    Save
                    <v-icon right>save</v-icon>
                  </v-btn>
                </div>
              </v-flex>
            </v-layout>
          </v-card>
        </v-flex>
      </v-layout>
    </v-form>

    <!-- Chart Of Account list dialog -->
    <v-dialog
      v-model="showChartOfAccountListDialog"
      scrollable
      max-width="1000px"
    >
      <v-card>
        <v-card-title class="mt-2">
          <v-flex xs3 offset-sm8>
            <div class="text-xs-right">
              <v-btn small color="primary" @click="addNewSubAccount">
                New Sub Account
                <v-icon right>add_circle</v-icon>
              </v-btn>
            </div>
          </v-flex>
        </v-card-title>
        <v-card-title>
          <!-- Search Section -->
          <v-layout wrap>
            <v-flex sm3 pl-1>
              <v-text-field
                name="code"
                label="Code"
                type="text"
                v-model="queryParams.code"
              ></v-text-field>
            </v-flex>
            <v-flex sm3 pl-1>
              <v-text-field
                name="accName"
                label="Name"
                type="text"
                v-model="queryParams.accName"
              ></v-text-field>
            </v-flex>
            <v-flex sm3 pl-1>
              <v-select
                :items="accHeadList"
                label="Account Head"
                v-model="queryParams.accountheadId"
                item-text="accountName"
                item-value="id"
              ></v-select>
            </v-flex>
            <v-flex sm2>
              <v-btn outline color="primary" @click="onSearch">
                Search
                <v-icon right>search</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <!-- Chart Of Account List Section -->
          <v-flex xs12 class="mt-1">
            <v-card>
              <v-data-table
                :headers="headers"
                :items="chartOfAccountList"
                class="elevation-1"
                :loading="showListLoading"
                :total-items="totalRows"
                :rows-per-page-items="rowsPerPageItems"
                :pagination.sync="pagination"
                :must-sort="true"
              >
                <template slot="items" slot-scope="props">
                  <td
                    @click="
                      setChartOfAccount(props.item.code),
                        (showChartOfAccountListDialog =
                          !showChartOfAccountListDialog)
                    "
                  >
                    <a>{{ props.item.code }}</a>
                  </td>
                  <td>{{ props.item.accName }}</td>
                  <td>{{ props.item.accType.accTypeName }}</td>
                  <td>{{ props.item.nature }}</td>
                  <td>{{ props.item.accounthead.accountName }}</td>
                </template>
              </v-data-table>
            </v-card>
          </v-flex>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { chartOfAccountService } from "../../services/chart-of-account-service";
import { accountTypeService } from "../../services/account-type-service";
import { accountHeadService } from "../../services/account-head-service";
import { ChartOfAccount } from "../../models/model";
import { ChartOfAccountFormRules } from "../../helpers/validation-rules";
import VSwitch from "vuetify/lib/components/VSwitch/VSwitch";
import { commonService } from "../../services/common-service";
export default {
  name: "ChartOfAccountDetail",
  components: { VSwitch },
  data: () => ({
    valid: true,
    user: JSON.parse(localStorage.getItem("user")),
    breadcrumbs: [
      {
        text: "Chart Of Account",
        disabled: false,
        to: "chart-of-accounts",
      },
      {
        text: "Account Detail",
        disabled: true,
      },
    ],
    prefixNo: "",
    statusFlag: true,
    carryOn: false,
    isOverride: false,
    hideTrial: false,
    isCash: false,
    previousTrial: false,
    updatedDate: "",
    createdDate: "",
    chartOfAccount: new ChartOfAccount(),
    oldChartOfAccount: new ChartOfAccount(),
    decimalFormat: "",
    saveLoading: false,
    isMFAccount: false,
    responseError: "",
    rules: new ChartOfAccountFormRules(),
    chartOfAccountList: [],
    showListLoading: false,
    showChartOfAccountListDialog: false,
    accountHeadList: [],
    accHeadList: [],
    accountTypeList: [],
    natureList: [
      { label: "DR", value: "DR" },
      { label: "CR", value: "CR" },
    ],
    headers: [
      { text: "Code", align: "left", value: "code" },
      { text: "Name", value: "accName" },
      { text: "Account Type", value: "accType.accTypeName" },
      { text: "Nature", value: "nature" },
      { text: "Account Head", value: "accountHead.accountName" },
    ],
    rowsPerPageItems: [25, 50, 100],
    pagination: {
      descending: true,
      page: 1,
      rowsPerPage: 50,
      sortBy: "updatedDate",
      totalItems: 0,
    },
    totalRows: 0,

    queryParams: {
      accName: "",
      code: "",
      accountheadId: "",
      status: "ACTIVE",
      isParent: false,
      isExistParent: false,
    },
  }),
  watch: {
    pagination: {
      handler() {
        this.getChartOfAccountList();
      },
      deep: true,
    },
  },
  created() {
    const id = this.$route.params.id;
    if (id == "new") {
      // new chartOfAccount
    } else {
      this.getChartOfAccountDetail(id);
    }
    this.getAllAccountHeadList();
    this.getAccountHeadList();
    this.getAccountTypeList();
    this.decimalFormat = commonService.formatdecimal();
  },
  methods: {
    onSave() {
      if (this.$refs.form.validate()) {
        this.saveLoading = true;

        this.chartOfAccount.status = this.statusFlag ? "ACTIVE" : "INACTIVE";
        this.chartOfAccount.carryOn = this.carryOn ? true : false;
        this.chartOfAccount.isOverride = this.isOverride ? true : false;
        this.chartOfAccount.previousTrial = this.previousTrial ? true : false;
        this.chartOfAccount.isHide = this.hideTrial ? true : false;
        this.chartOfAccount.isCash = this.isCash ? true : false;
        this.chartOfAccount.isMFAccount = this.isMFAccount ? true : false;

        this.chartOfAccount.subAccountList.forEach((detail) => {
          if (detail.isNew) detail.id = null;
        });
        chartOfAccountService
          .saveChartOfAccount(this.chartOfAccount)
          .then((res) => {
            console.log(res);
            this.goBack();
          })
          .catch((err) => {
            console.log(err);
            if (err.response.data) {
              this.responseError = err.response.data.message;
            }
            this.saveLoading = false;
          });
      }
    },
    getAccountTypeList() {
      accountTypeService
        .getAccountTypeByStatus("ACTIVE")
        .then((res) => {
          this.accountTypeList = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getChartOfAccountDetail(id) {
      chartOfAccountService
        .getChartOfAccountDetail(id)
        .then((res) => {
          this.chartOfAccount = res.data;
          this.carryOn = this.chartOfAccount.carryOn;
          this.isOverride = this.chartOfAccount.isOverride;
          this.previousTrial = this.chartOfAccount.previousTrial;
          this.hideTrial = this.chartOfAccount.isHide;
          this.isCash = this.chartOfAccount.isCash;
          this.isMFAccount = this.chartOfAccount.isMFAccount;
          this.createdDate = commonService.formatDate(
            new Date(this.chartOfAccount.createdDateInMilliSeconds)
              .toISOString()
              .substr(0, 10),
            "YYYY-MM-DD"
          );
          this.updatedDate = commonService.formatDate(
            new Date(this.chartOfAccount.updatedDateInMilliSeconds)
              .toISOString()
              .substr(0, 10),
            "YYYY-MM-DD"
          );
          let result = this.chartOfAccount.code.split("-");
          this.prefixNo = result[0];
          this.chartOfAccount.code = result[1];
          this.statusFlag =
            this.chartOfAccount.status == "ACTIVE" ? true : false;
          this.oldChartOfAccount = JSON.parse(JSON.stringify(res.data));
        })
        .catch((err) => {
          console.log(err);
        });
    },
    onSearch() {
      this.queryParams.page = this.pagination.page;
      this.queryParams.size = this.pagination.rowsPerPage;
      this.getChartOfAccountList();
    },
    getAllAccountHeadList() {
      accountHeadService
        .getAllAccountHead()
        .then((res) => {
          this.accountHeadList = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getAccountHeadList() {
      accountHeadService
        .getAllAccountHead()
        .then((res) => {
          this.accHeadList = res.data;
          let all = {
            id: "",
            accountName: "All",
          };
          this.accHeadList.splice(0, 0, JSON.parse(JSON.stringify(all)));
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getChartOfAccountList() {
      this.showListLoading = true;
      let order = this.pagination.descending ? "desc" : "asc";
      return chartOfAccountService
        .getChartOfAccountList(
          this.queryParams,
          this.pagination.page,
          this.pagination.rowsPerPage,
          this.pagination.sortBy + "," + order
        )
        .then((res) => {
          if (res.data) {
            this.chartOfAccountList = res.data.chartOfAccountList;
            this.totalRows = res.data.totalElements;
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.showListLoading = false;
        });
    },
    showChartOfAccounts() {
      // Clean query params
      this.queryParams.code = "";
      this.queryParams.accName = "";
      this.queryParams.accountheadId = "";
      this.getChartOfAccountList().then(
        (this.showChartOfAccountListDialog = !this.showChartOfAccountListDialog)
      );
    },
    addNewSubAccount() {
      let subAccount = {
        code: "",
        accName: "",
        totalOpeningBalance: 0,
      };
      this.chartOfAccount.subAccountList.push(subAccount);
      this.showChartOfAccountListDialog = !this.showChartOfAccountListDialog;
    },
    removeSubAccount(index, subAccountId) {
      if (subAccountId) {
        // add delete stock in id
        if (!this.chartOfAccount.deleteSubAccountIds) {
          this.chartOfAccount.deleteSubAccountIds = [];
        }
        this.chartOfAccount.deleteSubAccountIds.push(subAccountId);
      }
      this.$delete(this.chartOfAccount.subAccountList, index);
    },
    setChartOfAccount(code) {
      let coa = commonService.search("code", code, this.chartOfAccountList);
      this.chartOfAccount.subAccountList.push(coa);
    },

    changePrefix() {
      let accounthead = commonService.search(
        "id",
        this.chartOfAccount.accountheadId,
        this.accountHeadList
      );
      this.prefixNo = accounthead.prefixNo;
    },
    clear() {
      this.$refs.form.resetValidation();
      this.responseError = "";
      if (!this.chartOfAccount.id) {
        this.chartOfAccount = new ChartOfAccount();
        this.statusFlag = true;
      } else {
        this.chartOfAccount = JSON.parse(
          JSON.stringify(this.oldChartOfAccount)
        );
        this.statusFlag = this.chartOfAccount.status == "ACTIVE" ? true : false;
      }
    },
    goBack() {
      this.$router.push("/chart-of-accounts");
    },
  },
};
</script>
